import React from 'react'

const TextAreaJSX = ({ labelText, nameValue, onChange, value, maxLength }) => {
    return (
        <>
            <div className="col-md-12 mt-2">
                <div className='ms-2'>
                    <label htmlFor="" className='form-label  mb-0'>
                        {labelText}
                    </label>
                    <div className="icon-forms mb-3 mb-sm-0">
                        <textarea
                            type="text"
                            className="form-control"
                            id={`${nameValue}`}
                            name={`${nameValue}`}
                            value={value}
                            onChange={onChange}
                            maxLength={maxLength ?? 250}
                        // onBlur={formik.handleBlur}
                        ></textarea>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TextAreaJSX